"use strict";

var _createForOfIteratorHelper = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _toConsumableArray = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _regeneratorRuntime = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Utils_1 = require("@opengsn/common/dist/Utils");

var GSNContractsDataTypes_1 = require("@opengsn/common/dist/types/GSNContractsDataTypes");

exports.EmptyFilter = function () {
  return true;
};
/**
 * Basic score is reversed transaction fee, higher is better.
 * Relays that failed to respond recently will be downgraded for some period of time.
 */


exports.DefaultRelayScore = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(relay, txDetails, failures) {
    var _a, _b, gasLimit, gasPrice, pctFee, baseFee, transactionCost, score;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            gasLimit = parseInt((_a = txDetails.gas) !== null && _a !== void 0 ? _a : '0');
            gasPrice = parseInt((_b = txDetails.gasPrice) !== null && _b !== void 0 ? _b : '0');
            pctFee = parseInt(relay.pctRelayFee);
            baseFee = parseInt(relay.baseRelayFee);
            transactionCost = baseFee + gasLimit * gasPrice * (100 + pctFee) / 100;
            score = Math.max(Number.MAX_SAFE_INTEGER - transactionCost, 0);
            score = score * Math.pow(0.9, failures.length);
            return _context.abrupt("return", score);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var KnownRelaysManager = /*#__PURE__*/function () {
  function KnownRelaysManager(contractInteractor, logger, config, relayFilter, scoreCalculator) {
    _classCallCheck(this, KnownRelaysManager);

    this.latestScannedBlock = 0;
    this.relayFailures = new Map();
    this.preferredRelayers = [];
    this.allRelayers = [];
    this.config = config;
    this.logger = logger;
    this.relayFilter = relayFilter !== null && relayFilter !== void 0 ? relayFilter : exports.EmptyFilter;
    this.scoreCalculator = scoreCalculator !== null && scoreCalculator !== void 0 ? scoreCalculator : exports.DefaultRelayScore;
    this.contractInteractor = contractInteractor;
  }

  _createClass(KnownRelaysManager, [{
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var recentlyActiveRelayManagers;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._refreshFailures();

                _context2.next = 3;
                return this._fetchRecentlyActiveRelayManagers();

              case 3:
                recentlyActiveRelayManagers = _context2.sent;
                this.preferredRelayers = this.config.preferredRelays.map(function (relayUrl) {
                  return {
                    relayUrl: relayUrl
                  };
                });
                _context2.next = 7;
                return this.getRelayInfoForManagers(recentlyActiveRelayManagers);

              case 7:
                this.allRelayers = _context2.sent;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "getRelayInfoForManagers",
    value: function () {
      var _getRelayInfoForManagers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(relayManagers) {
        var toBlock, fromBlock, topics, relayServerRegisteredEvents, relayManagerExitEvents, mergedEvents, activeRelays, origRelays;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(relayManagers.size === 0)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", []);

              case 2:
                _context3.next = 4;
                return this.contractInteractor.getBlockNumber();

              case 4:
                toBlock = _context3.sent;
                fromBlock = Math.max(0, toBlock - this.config.relayRegistrationLookupBlocks);
                topics = Utils_1.addresses2topics(Array.from(relayManagers));
                _context3.next = 9;
                return this.contractInteractor.getPastEventsForHub(topics, {
                  fromBlock: fromBlock
                }, [GSNContractsDataTypes_1.RelayServerRegistered]);

              case 9:
                relayServerRegisteredEvents = _context3.sent;
                _context3.next = 12;
                return this.contractInteractor.getPastEventsForStakeManager([GSNContractsDataTypes_1.StakeUnlocked, GSNContractsDataTypes_1.HubUnauthorized, GSNContractsDataTypes_1.StakePenalized], topics, {
                  fromBlock: fromBlock
                });

              case 12:
                relayManagerExitEvents = _context3.sent;
                this.logger.info("== getRelayInfoForManagers: found ".concat(relayServerRegisteredEvents.length, " unique RelayServerRegistered events"));

                if (relayServerRegisteredEvents.length === 0) {
                  this.logger.error("Did not find any RelayServerRegistered Event for any of ".concat(relayManagers.size, " relay managers! {fromBlock: ").concat(fromBlock, ", toBlock: ").concat(toBlock, "}"));
                }

                mergedEvents = [].concat(_toConsumableArray(relayManagerExitEvents), _toConsumableArray(relayServerRegisteredEvents)).sort(function (a, b) {
                  var blockNumberA = a.blockNumber;
                  var blockNumberB = b.blockNumber;
                  var transactionIndexA = a.transactionIndex;
                  var transactionIndexB = b.transactionIndex;

                  if (blockNumberA === blockNumberB) {
                    return transactionIndexA - transactionIndexB;
                  }

                  return blockNumberA - blockNumberB;
                });
                activeRelays = new Map();
                mergedEvents.forEach(function (event) {
                  var args = event.returnValues;

                  if (event.event === GSNContractsDataTypes_1.RelayServerRegistered) {
                    activeRelays.set(args.relayManager, args);
                  } else {
                    activeRelays.delete(args.relayManager);
                  }
                });
                origRelays = Array.from(activeRelays.values());
                return _context3.abrupt("return", origRelays.filter(this.relayFilter));

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getRelayInfoForManagers(_x4) {
        return _getRelayInfoForManagers.apply(this, arguments);
      }

      return getRelayInfoForManagers;
    }()
  }, {
    key: "_fetchRecentlyActiveRelayManagers",
    value: function () {
      var _fetchRecentlyActiveRelayManagers2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var toBlock, fromBlock, relayEvents, foundRelayManagers;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.contractInteractor.getBlockNumber();

              case 2:
                toBlock = _context4.sent;
                fromBlock = Math.max(0, toBlock - this.config.relayLookupWindowBlocks);
                _context4.next = 6;
                return this.contractInteractor.getPastEventsForHub([], {
                  fromBlock: fromBlock,
                  toBlock: toBlock
                }, undefined);

              case 6:
                relayEvents = _context4.sent;
                this.logger.info("fetchRelaysAdded: found ".concat(relayEvents.length, " events"));
                foundRelayManagers = new Set();
                relayEvents.forEach(function (event) {
                  // TODO: remove relay managers who are not staked
                  // if (event.event === 'RelayRemoved') {
                  //   foundRelays.delete(event.returnValues.relay)
                  // } else {
                  foundRelayManagers.add(event.returnValues.relayManager);
                });
                this.logger.info("fetchRelaysAdded: found unique relays: ".concat(JSON.stringify(Array.from(foundRelayManagers.values()))));
                this.latestScannedBlock = toBlock;
                return _context4.abrupt("return", foundRelayManagers);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _fetchRecentlyActiveRelayManagers() {
        return _fetchRecentlyActiveRelayManagers2.apply(this, arguments);
      }

      return _fetchRecentlyActiveRelayManagers;
    }()
  }, {
    key: "_refreshFailures",
    value: function _refreshFailures() {
      var _this = this;

      var newMap = new Map();
      this.relayFailures.forEach(function (value, key) {
        newMap.set(key, value.filter(function (failure) {
          var elapsed = (new Date().getTime() - failure.lastErrorTime) / 1000;
          return elapsed < _this.config.relayTimeoutGrace;
        }));
      });
      this.relayFailures = newMap;
    }
  }, {
    key: "getRelaysSortedForTransaction",
    value: function () {
      var _getRelaysSortedForTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(gsnTransactionDetails) {
        var sortedRelays;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                sortedRelays = []; // preferred relays are copied as-is, unsorted (we don't have any info about them anyway to sort)

                sortedRelays[0] = Array.from(this.preferredRelayers);
                _context5.next = 4;
                return this._sortRelaysInternal(gsnTransactionDetails, this.allRelayers);

              case 4:
                sortedRelays[1] = _context5.sent;
                return _context5.abrupt("return", sortedRelays);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getRelaysSortedForTransaction(_x5) {
        return _getRelaysSortedForTransaction.apply(this, arguments);
      }

      return getRelaysSortedForTransaction;
    }()
  }, {
    key: "getAuditors",
    value: function getAuditors(excludeUrls) {
      var indexes = [];
      var auditors = [];
      var flatRelayers = [].concat(_toConsumableArray(this.preferredRelayers), _toConsumableArray(this.allRelayers)).map(function (it) {
        return it.relayUrl;
      }).filter(function (it) {
        return !excludeUrls.includes(it);
      }).filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });

      if (flatRelayers.length <= this.config.auditorsCount) {
        if (flatRelayers.length < this.config.auditorsCount) {
          this.logger.warn("Not enough auditors: request ".concat(this.config.auditorsCount, " but only have ").concat(flatRelayers.length));
        }

        return flatRelayers;
      }

      do {
        var index = Math.floor(Math.random() * flatRelayers.length);

        if (!indexes.includes(index)) {
          auditors.push(flatRelayers[index]);
          indexes.push(index);
        }
      } while (auditors.length < this.config.auditorsCount);

      return auditors;
    }
  }, {
    key: "_sortRelaysInternal",
    value: function () {
      var _sortRelaysInternal2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(gsnTransactionDetails, activeRelays) {
        var _a, scores, _iterator, _step, activeRelay, score, eventInfo;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                scores = new Map();
                _iterator = _createForOfIteratorHelper(activeRelays);
                _context6.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context6.next = 15;
                  break;
                }

                activeRelay = _step.value;
                score = 0;

                if (!GSNContractsDataTypes_1.isInfoFromEvent(activeRelay)) {
                  _context6.next = 13;
                  break;
                }

                eventInfo = activeRelay;
                _context6.next = 11;
                return this.scoreCalculator(eventInfo, gsnTransactionDetails, (_a = this.relayFailures.get(activeRelay.relayUrl)) !== null && _a !== void 0 ? _a : []);

              case 11:
                score = _context6.sent;
                scores.set(eventInfo.relayManager, score);

              case 13:
                _context6.next = 4;
                break;

              case 15:
                _context6.next = 20;
                break;

              case 17:
                _context6.prev = 17;
                _context6.t0 = _context6["catch"](2);

                _iterator.e(_context6.t0);

              case 20:
                _context6.prev = 20;

                _iterator.f();

                return _context6.finish(20);

              case 23:
                return _context6.abrupt("return", Array.from(activeRelays.values()).filter(GSNContractsDataTypes_1.isInfoFromEvent).map(function (value) {
                  return value;
                }).sort(function (a, b) {
                  var _a, _b;

                  var aScore = (_a = scores.get(a.relayManager)) !== null && _a !== void 0 ? _a : 0;
                  var bScore = (_b = scores.get(b.relayManager)) !== null && _b !== void 0 ? _b : 0;
                  return bScore - aScore;
                }));

              case 24:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 17, 20, 23]]);
      }));

      function _sortRelaysInternal(_x6, _x7) {
        return _sortRelaysInternal2.apply(this, arguments);
      }

      return _sortRelaysInternal;
    }()
  }, {
    key: "saveRelayFailure",
    value: function saveRelayFailure(lastErrorTime, relayManager, relayUrl) {
      var relayFailures = this.relayFailures.get(relayUrl);
      var newFailureInfo = {
        lastErrorTime: lastErrorTime,
        relayManager: relayManager,
        relayUrl: relayUrl
      };

      if (relayFailures == null) {
        this.relayFailures.set(relayUrl, [newFailureInfo]);
      } else {
        relayFailures.push(newFailureInfo);
      }
    }
  }]);

  return KnownRelaysManager;
}();

exports.KnownRelaysManager = KnownRelaysManager;